var _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetupHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 40C0.5 61.8153 18.1847 79.5 40 79.5C61.8152 79.5 79.5 61.8153 79.5 40C79.5 18.1848 61.8152 0.5 40 0.5C18.1847 0.5 0.5 18.1848 0.5 40Z",
    fill: "#FDE8F2",
    stroke: "#EC187B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 36C25.0883 36 13 48.0883 13 63C13 64.7782 13.1719 67.3178 13.5 69C22 78.3015 44.9 86.7588 66.5 69C66.8281 67.3178 67 64.7782 67 63C67 48.0883 54.9117 36 40 36Z",
    fill: "#EC187B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 24,
    r: 12,
    fill: "#EC187B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.977 36.4757C39.9489 36.4754 39.9208 36.4752 39.8927 36.4752C38.6618 36.4752 37.4498 36.779 36.3644 37.3595L35.9372 37.588C34.5296 38.3408 34.6387 40.3938 36.1181 40.9932L37.3714 41.5011L34.6005 49.5247C33.8211 51.7815 33.875 54.2427 34.7522 56.4632L39.8927 69.4752L45.2017 56.5117C46.1228 54.2626 46.1933 51.755 45.3999 49.4577L42.6049 41.3641L43.6319 40.9607C45.1133 40.3789 45.2333 38.3288 43.8299 37.5781L43.4211 37.3595C42.3953 36.8109 41.2566 36.5095 40.0956 36.478C40.0678 36.4761 40.0399 36.4752 40.0118 36.4752C40.0001 36.4752 39.9885 36.4754 39.977 36.4757Z",
    fill: "#FDE8F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupHover);
export default __webpack_public_path__ + "static/media/setupHover.a5690120df0a66373a650e0d9bdbb1ea.svg";
export { ForwardRef as ReactComponent };